import React from 'react'

interface IWithdrawalAccount {
  _id: string
  name: string
  bankNo: string
  isSelected: boolean
  setSelectedAccount: React.Dispatch<React.SetStateAction<string>>
}

const SelectedIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_101_2)'>
        <path
          d='M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z'
          fill='#00C693'
        />
        <path
          d='M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z'
          fill='#09614A'
        />
      </g>
      <defs>
        <clipPath id='clip0_101_2'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const WithdrawalAccount = ({
  _id,
  name,
  bankNo,
  isSelected,
  setSelectedAccount,
}: IWithdrawalAccount) => {
  return (
    <div
      className='transition-all duration-200 cursor-pointer px-4 py-3 rounded-lg bg-gray-700 hover:bg-gray-600 border border-dashed border-zinc-600 flex gap-2'
      onClick={() => setSelectedAccount(_id)}
    >
      {isSelected ? (
        <div className='mt-[2px]'>
          <SelectedIcon />
        </div>
      ) : (
        <div className='h-[18px] w-[18px] rounded-full bg-gray-400 mt-[2px]' />
      )}

      <div className='flex flex-col gap-1'>
        <p className='text-sm font-light text-white/50'>{name}</p>
        <p className='text-white text-base'>{bankNo}</p>
      </div>
    </div>
  )
}
